@if (!team || isLoading) {
  <div class="loading-container">
    <app-loading-logo></app-loading-logo>
  </div>
} @else {
  <div class="content">
    <app-roles-icon
      id="roles-icon"
      backgroundSize="100px"
      size="90px"
      [style.margin-top]="marginTop"
    ></app-roles-icon>
    <div class="title truncate">{{ team.name }}</div>
    @if (userWorkspace) {
      <div class="workspace-container">
        <div class="name">{{ userWorkspace.workspace.name }}</div>
        @if (userWorkspace.workspace.verificationStatus === "Verified") {
          <img
            id="verification-icon"
            src="../../../../assets/icons/ic-verified-workspace.svg"
          />
        }
      </div>
    }
    @if (team.isActive) {
      @if (!hidePrimaryAction) {
        <div class="flex g-10px mb-30">
          @if (isMember) {
            <button
              mat-button
              class="celo-secondary-button uppercase"
              (click)="editRoleDetails()"
            >
              Edit Details
            </button>
          }
          <button
            mat-button
            class="celo-secondary-button uppercase"
            (click)="handleClick()"
          >
            {{ isMember ? "View Role Inbox" : "Secure Message" }}
          </button>
        </div>
      }
      @if ((isMember && hidePrimaryAction) || team.description) {
        <div class="flex justify-between w-full items-center">
          <div class="heading">
            {{ !isMember || !hidePrimaryAction ? "Description" : "Details" }}
          </div>
          @if (isMember && hidePrimaryAction) {
            <button
              id="add-members-button"
              class="celo-link"
              mat-button
              (click)="editRoleDetails()"
            >
              Edit
            </button>
          }
        </div>
        <mat-divider [class.mb-10]="!hidePrimaryAction"></mat-divider>
      }
      @if ((isMember && hidePrimaryAction) || team.description) {
        <app-role-details-form
          [teamId]="team.id"
          [name]="team.name"
          [description]="(team.description | trim) || 'No Description'"
          [readonly]="true"
          [hideName]="!isMember || !hidePrimaryAction"
          [hideDescriptionHeader]="!isMember || !hidePrimaryAction"
        ></app-role-details-form>
      }
      @if (!hidePrimaryAction && team.description) {
        <mat-divider></mat-divider>
      }
      <div class="flex justify-between w-full items-center mt-24">
        <div class="heading">Members</div>
        @if (isCurrentUserAdmin) {
          <button
            id="add-members-button"
            class="celo-link"
            mat-button
            (click)="handleAddMembers()"
          >
            Add new members
          </button>
        }
      </div>
      <mat-divider></mat-divider>
      <app-roles-members-list
        id="members-list"
        [style.max-height]="membersListMaxHeight"
        [members]="sortedTeamMembers"
        [team]="team"
      ></app-roles-members-list>
      @if (!hidePrimaryAction) {
        <mat-divider class="mt-4"></mat-divider>
      }
      @if (isMember) {
        <button
          id="leave-button"
          class="celo-hoverable celo-cursor-pointer"
          mat-button
          (click)="handleLeaveClick()"
        >
          Leave this role
        </button>
      }
    } @else {
      <div class="mat-body mt-20">This role has been deactivated.</div>
    }
  </div>
}
